import BaseNodeModel from "../BaseNodeModel";
import UserTypeStorage from "../../utilities/UserTypeStorage";

export default class CustomNodeModel extends BaseNodeModel {
    /**
     * Custom node model
     * @module CustomNodeModel
     * @param {string} nodeName Node display name
     * @param {number} x Node x coordinate on canvas
     * @param {number} y Node y coordinate on canvas
     * @param {Object} props Pre-defined node properties; if non-null, apply values to node properties
     * @param {string} id If non-null, use this ID as the node ID
     */
    constructor(nodeName = "UNTITLED_NODE", x = 0, y = 0, props = null, id = null) {
        super(nodeName, x, y, null, id);
        this.props.nodeTypeName = "Custom Script";
        this.props.colorClass = "green";
        this.props.iconClass = "cpu";
        this.props.config = {
            functionType: "CUSTOM"
        };
        this.DEFAULT_COLOR_CLASS = "green";
        this.applyProps(props);
    }

    getConfig(key) {
        let f;
        if (key === "script") {
            // Read the correct script text based on what function the node is using
            if (this.props.config.functionType === "CUSTOM" && this.props.config.function) {
                return this.props.config.function.script ? this.props.config.function.script : "";
            }

            if (this.props.config.functionType === "REUSEABLE" && this.props.config.function && this.props.config.function.ref) {
               
                    f = window.apm.knowledgeBase.getFunctions(this.props.config.function.ref);
                
                if (f) {
                    return f.script;
                }
            }
        }
        return super.getConfig(key);
    }

    setConfig(key, value) {
        super.setConfig(key, value);
        
        if (key === "functionType") {
            // Refresh property panel when changing what function the node is using
            document.dispatchEvent(new CustomEvent("ev-property-refresh"));
        }
        if (key === "function" && !this.isCommonModule) {
            this.props.lastLocalChange = window.apm.timestamp;
            // update node inputs and outputs
            if (value.arguments) {
                this.props.config["inputs"] = JSON.parse(JSON.stringify(value.arguments));
            }
            if (value.outputs) {
                this.props.config["outputs"] = JSON.parse(JSON.stringify(value.outputs));
            }
        }
    }

    getConfigViews() {
        const functionType = this.getConfig("functionType") ? this.getConfig("functionType") : "CUSTOM";
        this.props.configView = [];
        
        if(['designer','developer','quality'].indexOf(UserTypeStorage.getUserType()) !== -1){
            this.props.configView.push({   type: "hr"});
        }

        this.props.configView.push(
            {
                type: "Dropdown",
                userType: ['designer','developer','quality'],
                label: this.getPropLabel("function_type"),
                key: "functionType",
                optionName: this.getPropLabel("function_type_opt"),
                options: [
                    { name: "Custom Function", value: "CUSTOM" }, { name: "Reuseable Function", value: "REUSEABLE" }
                ]
            },
            {
                type: "Function",
                userType: ['designer','developer', 'quality'],
                key: "function",
                functionType: functionType 
            }
        );
        
        
        return [
            ...this.getConfigViewNameField(),
            ...[
                {type: "Textarea", label: this.getPropLabel("description"), key: "description", valRules: { "noEmpty": true }}
            ],
            ...this.props.configView,
            ...[
                { type: "hr" },
                { type: "Textarea", label: this.getPropLabel("note"), key: "note"}
            ]
        ];
    }

}